export default {"src":"/_next/static/media/disk.959d5250.svg","height":21,"width":24};